//helpers
import getWebsiteUrl from "./getWebsiteUrl";
import type { Sizes, Qualities } from "@adjust/libs/imageConfig";

function getImageLoaderSrc(src: string, width: Sizes, quality: Qualities = 75) {
  return getWebsiteUrl(`/_next/image/?url=${encodeURIComponent(src)}&w=${width}&q=${quality}`, true);
}

export default getImageLoaderSrc;
